import { ElementRef } from "@angular/core";
export abstract class CustomMapThemeExe {
  setCustomHtml(customHtmlConfig: any, customHtmlElement: ElementRef): void {}
  setCustomMap(customMapConfig: any, map: any): void {}
}
